import { Translate } from '../../shared/LanguageService';
import { UserRole } from '../../components/common/header/photo/head-bar/newsComponent/utils/userRoleHelper';

type ValidationErrors = { [key: string]: string };

type NewsValidationItem = {
    title: string;
    content: string;
    startDate: string | null;
    visibleDate: string | null;
    endDate: string | null;
    recipients: { role: UserRole | string }[];
    brokerChainIds: number[];
};

export function getEndDateError(
    startDate: string | null,
    endDate: string | null
): string | undefined {
    if (!endDate) return undefined;
    if (startDate && endDate < startDate) {
        return Translate('news-editor-modal/validations/end-date-after-start-date');
    }
    return undefined;
}

function hasText(html: string): boolean {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    return (parsed.body.textContent || '').trim().length > 0;
}

export function validateNewsForPublish(item: NewsValidationItem): ValidationErrors {
    const errors: ValidationErrors = {};

    if (!item.title.trim()) {
        errors.title = Translate('news-editor-modal/validations/title');
    }

    if (!hasText(item.content)) {
        errors.content = Translate('news-editor-modal/validations/content');
    }

    if (!item.startDate) {
        errors.startDate = Translate('news-editor-modal/validations/start-date');
    }

    if (!item.visibleDate) {
        errors.visibleDate = Translate('news-editor-modal/validations/visible-date');
    }

    const endDateError = getEndDateError(item.startDate, item.endDate);
    if (endDateError) {
        errors.endDate = endDateError;
    }

    if (item.recipients.length === 0) {
        errors.recipients = Translate('news-editor-modal/validations/recipients');
    }

    const hasBrokerAgentRecipient = item.recipients.some(
        (recipient) => recipient.role === UserRole.BrokerAgent
    );
    if (hasBrokerAgentRecipient && item.brokerChainIds.length === 0) {
        errors.brokerChain = Translate('news-editor-modal/validations/broker-chain');
    }

    return errors;
}
